import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import messages_en from './i18n/en/resource';
import messages_es from './i18n/es/resource';

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    translation: messages_en,
  },
  es: {
    translation: messages_es,
  },
};

export const initI18Next = (lookupCookie, useLanguageAutodetect) => {
  i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .use(LanguageDetector)
    .init({
      resources,
      detection: {
        lookupCookie: lookupCookie || 'django_language',
        order: useLanguageAutodetect
          ? ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag']
          : ['cookie'],
      },
      supportedLngs: ['pt', 'en', 'es'],
      fallbackLng: 'pt',
      keySeparator: false, // we do not use keys in form messages.welcome
      nsSeparator: false, //we do not use namespaces
      interpolation: {
        escapeValue: false, // react already safes from xss
      },
    });
};

export default i18n;

export function t(key, options) {
  return i18n.t(key, options) || key;
}
